import { getPublicBucketUrl } from '@advanza/func'
import { createElement, CSSProperties, useEffect, useState } from 'react'
import { S3_PUBLIC } from '../constants'
import css from './icon.module.css'

export const isIconName = (str: string) => /^([a-z0-9_]+|\/.*)$/.test(str)

interface Props {
    children?: string
    name?: string
    primColor?: boolean
    green?: boolean
    grey?: boolean
    red?: boolean
    orange?: boolean
    white?: boolean
    className?: string
    classNameIcon?: string
    style?: CSSProperties
    fontSize?: number
    /** @deprecated pass a S3 path (with starting / and extension) directly in 'name' */
    s3?: boolean
    /** @deprecated */
    s3Dir?: string
    /** @deprecated */
    fileName?: string
    /** @deprecated */
    ext?: 'svg' | string
    theme?: 'outlined' | 'filled'
    [x: string]: any
}

const Icon = ({
    children = '',
    name = '',
    primColor = undefined,
    green = undefined,
    grey = undefined,
    red = undefined,
    orange = undefined,
    white = undefined,
    blue = undefined,
    className = undefined,
    classNameIcon = undefined,
    style = {},
    fontSize = undefined,
    s3: s3Prop = undefined,
    fileName = undefined,
    s3Dir = 'icon/pro',
    ext = 'svg',
    theme = 'outlined',
    ...rest
}: Props) => {
    const [fontsLoaded, setFontsLoaded] = useState(false)
    useEffect(() => {
        document.fonts.ready.then(() => setFontsLoaded(true))
    }, [])
    const classNames = [
        'material-symbols-outlined',
        css.icon,
        (className && css[className]) || '',
        primColor ? css.colorPrimary : '',
        green ? css.green : '',
        grey ? css.grey : '',
        red ? css.red : '',
        orange ? css.orange : '',
        white ? css.colorWhite : '',
        blue ? css.blue : '',
        theme == 'filled' ? css.fill : '',
        classNameIcon ? classNameIcon : '',
    ].join(' ')
    const extraStyle: CSSProperties = {}

    const nameIsS3Path = typeof name === 'string' && name.startsWith('/')
    const s3 = s3Prop || nameIsS3Path

    if (fontSize && fontSize < 21) {
        extraStyle.transform = 'rotate(0.03deg)'
    }

    if (fontSize) {
        extraStyle.fontSize = fontSize
    }

    if (s3) {
        extraStyle.width = '1em'
    }

    if (!fontsLoaded && !s3) {
        extraStyle.fontSize = 0
        extraStyle.width = fontSize
        extraStyle.height = fontSize
    }

    const tagName = s3 ? 'img' : 'i'
    const extraProps = { ...rest }

    if (s3) {
        extraProps.src = nameIsS3Path
            ? getPublicBucketUrl() + name
            : `${S3_PUBLIC()}${s3Dir}/${fileName || name + '.' + ext}`
    }

    return createElement(
        tagName,
        {
            className: classNames,
            ...extraProps,
            style: { ...extraStyle, ...style },
        },
        s3 ? undefined : name || children,
    )
}

export default Icon
